import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { ROUTES } from '../../utils/routes';
import { notFoundErrorReset } from '../../store/feedback-actions';
import { useAppDispatch, useAppSelector } from '../../../store/store';

export const NotFoundHandler = (): null => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const notFound = useAppSelector(state => state.feedback.notFoundError);

    useEffect(() => {
        if (notFound) {
            dispatch(notFoundErrorReset());
            navigate(ROUTES.notFound);
        }
    }, [notFound, navigate, dispatch]);

    return null;
};
